import RequestChannelFieldsReferenceId from './reference-id';

export default { 'reference-id': RequestChannelFieldsReferenceId };
